import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { BadgeComponent, SeverityBadgeDirective } from '@workbuddy/ui/components/badge';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { TaskCompletionDialogContent, TaskCompletionRowTone } from './task.completion.dialog.content';
import { isAuthorisingTaskCompletionDialog } from './task.completion.dialog.kind';
import { taskCompletionBlockersBridgeStyles, taskCompletionBlockersStyleId } from './task.completion.blockers.theme';

/** Why a task cannot be completed, or what completing it would authorise, as rows the content names. The host projects the opt-in for an authorisation. */
@Component({
  selector: 'task-completion-blockers',
  templateUrl: 'task.completion.blockers.component.html',
  styleUrls: ['task.completion.blockers.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeComponent, SeverityBadgeDirective],
  host: { '[class.overridable]': '$overridable()' },
})
export class TaskCompletionBlockersComponent {

  public readonly $content = input.required<TaskCompletionDialogContent>({ alias: 'content' });

  protected readonly $overridable = computed(() => isAuthorisingTaskCompletionDialog(this.$content().kind));
  protected readonly attention = TaskCompletionRowTone.Attention;
  protected readonly unchanged = TaskCompletionRowTone.Unchanged;

  private readonly document = inject(DOCUMENT);

  public constructor() {

    DesignSystem.Mount(this.document, taskCompletionBlockersStyleId, taskCompletionBlockersBridgeStyles);
  }
}
